module.exports = __webpack_public_path__ + "static/img/qhdx.ac3192c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qhdx.png
// module id = qilO
// module chunks = 0